
/**
 * Popup message to the user
 * @param type = string (good, bad, default, etc)
 * @param message = string (words to show)
 * @param extraClasses = string (optional)
 * @param sticky = boolean (optional, don't timeout and hide)
 **/
export function Create(type, message, extraClasses, sticky){
	
	if (typeof(extraClasses) === 'undefined') var extraClasses = '';
	if (typeof(sticky) === 'undefined') var sticky = false;
	
	var popup = $('<div class="notifications__item notifications__item--'+type+''+extraClasses+'">'+message+'</div>');
	$(document).find('#notifications').append(popup);	

	popup.fadeIn('fast');
	
	if (!sticky){
		popup.delay(3000).fadeOut(
			'slow', 
			function(){ 
				popup.remove()
			}
		);
	}
}



/**
 * Create a popup and inject the message content
 * @var field = top-level field DOM
 * @var signaturePad = signature pad object (canvas)
**/
export function CreateHelpPopup( content ){
	
	// if the popup content doesn't exist
	if( !$(document).find('.help-popup').length > 0 ){
	
		// create popup markup
		$('body').append('<div class="help-popup" style="display: none;"><div class="inner"><div class="help-close"><span class="online-form-icon close"></span></div><div class="help-popup-content"></div></div></div>');
	}
	
	// inject content
	$(document).find('.help-popup-content').html( content );
	$(document).find('.help-popup').fadeIn('fast');
	
	// on click of background
	$(document).on('click tap', '.help-popup', function(evt){
		if( evt.target === this ) 
			$(document).find('.help-popup').fadeOut('fast', function(){ $(this).remove() } );
	});
	
	// click of close button
	$(document).on('click tap', '.help-close', function(evt){
		$(document).find('.help-popup').fadeOut('fast', function(){ $(this).remove() } );
	});
	
	// tap of esc key
	$(document).keyup(function(e) {
		if (e.keyCode == 27) {
			$(document).find('.help-popup').fadeOut('fast', function(){ $(this).remove() } );
		}
	});	
}




